export enum ProcessFlowFindDataLimitType {
  Number = 1,
  Percentage = 2,
  Variable = 3,
}